import * as React from 'react';
import { ContentView } from '@levelapp/softfabric';
import StepViewStyle from './StepViewStyle';
import StepViewModel from './StepViewModel';
import { View, TouchableWithoutFeedback, Text, Image } from 'react-native';
export default class StepView extends ContentView {
    /* CONSTRUCTOR */
    constructor(props) {
        super(props);
        // Binding
        this.bind(new StepViewModel(this), new StepViewStyle(this));
    }
    /* RENDERING */
    render() {
        this.binding.getCurrentPage();
        var displayPage = [];
        for (let i = 0; i < this.props.numberDisplays; i++) {
            displayPage
                .push(React.createElement(TouchableWithoutFeedback, { onPress: () => this.binding.onPress(i), key: i, style: [this.style.circle] },
                React.createElement(View, { style: [this.state.currentPage == i ? [this.style.choose, this.props.styleOfChoosenButton] : this.style.circle] },
                    React.createElement(Text, { style: [this.state.currentPage == i ? this.style.chooseText : this.style.text] },
                        " ",
                        i + 1))));
        }
        return (React.createElement(View, { style: [this.style.container, this.props.style] },
            React.createElement(TouchableWithoutFeedback, { onPress: this.binding.goLeft, style: [this.style.circle] },
                React.createElement(View, { style: this.state.currentPage == 0 ? this.style.dontDisplay : [this.style.circle,] },
                    React.createElement(Image, { style: { height: 20, width: 20, alignSelf: 'center' }, source: require('./assets/arrowLeft.png') }))),
            displayPage,
            React.createElement(TouchableWithoutFeedback, { onPress: this.binding.goRight, style: [this.style.circle] },
                React.createElement(View, { style: [this.state.currentPage == this.props.numberDisplays - 1 ? this.style.dontDisplay : this.style.circle] },
                    React.createElement(Image, { style: { height: 20, width: 20, alignSelf: 'center' }, source: require('./assets/arrowRight.png') })))));
    }
}
